import PortalIdParser from 'PortalIdParser';
export const getInvoicesURL = () => `/invoices/${PortalIdParser.get()}`;